import React from "react";
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";

export default ({ label, href, disabled, action }) => (
    <Button fullWidth
            size="large"
            color="primary"
            disabled={disabled}
            onClick={action}
            style={{ height: 49 }}
            target="_blank"
            component={Link}
            to={href}
            variant="outlined" >
        {label}
    </Button>
);



// WEBPACK FOOTER //
// ./src/components/PrintLink.js